document.addEventListener(
  "change",
  function (e) {
    const radio = e.target.closest('input[type="radio"][name^="option-"]');
    if (!radio) return;

    const form = radio.closest('form[action^="/cart/add"]');
    if (!form) return;

    const productData = window.productJSON;
    if (!productData || !productData.variants) return;

    // Build selected options from checked radios (not selects)
    const optionCount = (productData.options || []).length;
    const selectedOptions = [];
    for (let i = 0; i < optionCount; i++) {
      const checked = form.querySelector(`input[name="option-${i}"]:checked`);
      selectedOptions.push(checked ? checked.value : null);
    }

    if (selectedOptions.some(v => v === null)) return;

    const matched = productData.variants.find(v => {
      if (!v.options || v.options.length !== selectedOptions.length) return false;
      return v.options.every((opt, idx) => opt === selectedOptions[idx]);
    });

    if (!matched) return;

    const variantSelect = form.querySelector('select[name="id"]');
    if (!variantSelect) return;

    variantSelect.value = String(matched.id);
    variantSelect.dispatchEvent(new Event("change", { bubbles: true }));
    // ---- PRICE UPDATE FIX (AVERY SAFE) ----
const priceMoneyEl =
  document.querySelector('[id^="ProductPrice-"] .money') ||
  document.querySelector('#product-description .product-price-current .money');

const compareMoneyEl =
  document.querySelector('[id^="ComparePrice-"] .money') ||
  document.querySelector('#product-description .product-price-list .money');

const moneyFormat =
  window.shopMoneyFormat ||
  (window.theme && window.theme.moneyFormat) ||
  Shopify.money_format;

if (priceMoneyEl) {
  priceMoneyEl.innerHTML = Shopify.formatMoney(matched.price, moneyFormat);
}

if (compareMoneyEl) {
  if (matched.compare_at_price && matched.compare_at_price > matched.price) {
    compareMoneyEl.innerHTML = Shopify.formatMoney(matched.compare_at_price, moneyFormat);
  } else {
    compareMoneyEl.innerHTML = "";
  }
}
// ---- END PRICE UPDATE FIX ----
  },
  true
);
// Hard override for Add to Cart to prevent theme/app hijack that causes "items" error
document.addEventListener(
  "submit",
  async function (e) {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;

    // Only intercept Shopify product forms that post to /cart/add
    if (!form.action || !form.action.includes("/cart/add")) return;

    // Stop other scripts from hijacking
    e.preventDefault();
    e.stopImmediatePropagation();

    const fd = new FormData(form);
    const id = fd.get("id");
    const quantity = fd.get("quantity") || "1";

    if (!id) {
      alert("Variant ID missing. Please select size and color.");
      return;
    }

    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { Accept: "application/json" },
        body: new URLSearchParams({ id: String(id), quantity: String(quantity) }),
      });

      if (!res.ok) {
        const text = await res.text();
        console.error("Add to cart failed:", text);
        alert("Add to cart failed. Check console for details.");
        return;
      }

      window.location.href = "/cart";
    } catch (err) {
      console.error(err);
      alert("Add to cart failed due to a script/network error.");
    }
  },
  true
);

document.addEventListener("DOMContentLoaded", function () {
  const form = document.querySelector('form[action^="/cart/add"]');
  const productData = window.productJSON;
  if (!form || !productData || !Array.isArray(productData.variants)) return;

  const params = new URLSearchParams(window.location.search);
  const variantIdFromUrl = params.get("variant");
  if (!variantIdFromUrl) return;

  const current = productData.variants.find(v => String(v.id) === String(variantIdFromUrl));
  if (!current) return;

  // If variant is available, still sync state to be safe
  // If NOT available, switch to first available variant with same "color" option
  let target = current;

  // Try to detect which option index is Color
  const colorOptionIndex = (() => {
    // productData.options is usually ["Color", "Size"] in Shopify JSON
    if (Array.isArray(productData.options)) {
      const idx = productData.options.findIndex(o =>
        String(o).toLowerCase().includes("color") || String(o).toLowerCase().includes("colour")
      );
      return idx >= 0 ? idx : 0; // fallback to option1
    }
    return 0;
  })();

  if (current.available === false) {
    const colorValue = Array.isArray(current.options) ? current.options[colorOptionIndex] : null;

    // Pick first available variant matching same color (any size)
    const candidate = productData.variants.find(v =>
      v.available === true &&
      Array.isArray(v.options) &&
      v.options[colorOptionIndex] === colorValue
    );

    if (candidate) target = candidate;
  }

  // If we changed variant, update URL without reloading page
  if (String(target.id) !== String(current.id)) {
    params.set("variant", String(target.id));
    const newUrl = `${window.location.pathname}?${params.toString()}`;
    window.history.replaceState({}, "", newUrl);
  }

  // Sync Shopify variant select
  const variantSelect = form.querySelector('select[name="id"]');
  if (variantSelect) {
    variantSelect.value = String(target.id);
    variantSelect.dispatchEvent(new Event("change", { bubbles: true }));
  }

  // Sync option dropdowns
  const optionSelects = form.querySelectorAll(".single-option-selector");
  if (Array.isArray(target.options)) {
    target.options.forEach((opt, idx) => {
      if (optionSelects[idx]) {
        optionSelects[idx].value = opt;
        optionSelects[idx].dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  }

  // Sync swatch radios
  if (Array.isArray(target.options)) {
    target.options.forEach((opt, idx) => {
      const radios = form.querySelectorAll(`input[type="radio"][name="option-${idx}"]`);
      radios.forEach(r => {
        if (r.value === opt) {
          r.checked = true;
          r.dispatchEvent(new Event("change", { bubbles: true }));
        }
      });
    });
  }
});

document.addEventListener("change", function (e) {

  const radio = e.target.closest('input[type="radio"][name^="option-"]');
  if (!radio) return;

  const form = radio.closest('form[action^="/cart/add"]');
  if (!form) return;

  const productData = window.productJSON;
  if (!productData || !Array.isArray(productData.variants)) return;

  const optionSelects = form.querySelectorAll(".single-option-selector");
  const selectedOptions = Array.from(optionSelects).map(s => s.value);

  const matched = productData.variants.find(v =>
    Array.isArray(v.options) &&
    v.options.length === selectedOptions.length &&
    v.options.every((opt, idx) => opt === selectedOptions[idx])
  );

  const addBtn = form.querySelector('[type="submit"][name="add"]');
  const inventoryEl = document.getElementById("variant-inventory");

  if (!matched || !matched.available) {
    if (addBtn) addBtn.disabled = true;
    if (inventoryEl) inventoryEl.textContent = "Out of stock";
  } else {
    if (addBtn) addBtn.disabled = false;
    if (inventoryEl) inventoryEl.textContent = "In stock";
  }

});

